export default "__VITE_ASSET__3617bb9f__"